import _has from 'lodash/has'

export const getItemType = item => {
  if (_has(item, 'id') && _has(item, 'is_waiver')) {
    return 'waiver'
  } else if (_has(item, 'id') /*&& _has(item, 'download_url')*/) {
    return 'attachment'
  } else if (_has(item, 'label') && _has(item, 'url')) {
    return 'link'
  } else if (_has(item, 'label') && _has(item, 'content')) {
    return 'page'
  }
}
